module.exports = __webpack_public_path__ + "img/b1.e21fa582.png";